module.exports = "https://tutorchat.chegg.com/static/media/ic-undo.c6b4ffd1.svg";